<template>
  <div>
    <template v-for="item in productPageList">
      <div class="row border-bottom" :key="item.recordId" style="word-break:break-all;">
        <div class="col-xl-12">
          <div class="row">
            <div class="col-xl-12 text-right p-1">
              <b-button class="px-1 py-1" variant="primary" size="sm" v-if="item.status == 1" v-on:click="openUpload(item)">
                <span>{{$t('ONLINE.Attachment_management')}}</span>
              </b-button>&nbsp;
              <b-button class="px-1 py-1" variant="primary" size="sm" v-if="item.status == 1" v-on:click="updateOrder(item)">{{$t('CONTENT.Edit')}}</b-button>&nbsp;
              <b-button class="px-1 py-1" variant="primary" size="sm" v-if="item.status == 1" v-on:click="confirmTheOrder(item,2)">{{$t('CONTENT.CONFIRM')}}</b-button>&nbsp;
              <b-button class="px-1 py-1" variant="danger" size="sm" v-if="item.status == 1" v-on:click="deleteOrder(item)">{{$t('CONTENT.Delete')}}</b-button>
              <b-button class="px-1 py-1" variant="primary" size="sm" v-if="item.status == 2 && user.manageFlag" v-on:click="confirmTheOrder(item,3)">{{$t('CONTENT.Audit')}}</b-button>&nbsp;
              <b-button class="px-1 py-1" variant="primary" size="sm" v-if="item.status == 2 && user.manageFlag" v-on:click="repulseOrder(item,1)">{{$t('CONTENT.Repulse')}}</b-button>&nbsp;
              <b-button class="px-1 py-1" variant="primary" size="sm" v-if="item.status == 3 && user.manageFlag" v-on:click="confirmTheOrder(item,4)">{{$t('CONTENT.Pay_Comfirm')}}</b-button>&nbsp;
              <b-button class="px-1 py-1" variant="primary" size="sm" v-if="item.status == 3 && user.manageFlag" v-on:click="repulseOrder(item,2)">{{$t('CONTENT.Repulse')}}</b-button>&nbsp;
            </div>
          </div>
          <div class="row">
            <div class="col-xl-12 p-1">
              <label v-if="item.no">
                <span class="text-muted">{{$t('ONLINE.Order_Number')}}:&nbsp;</span>{{item.no}}&nbsp;&nbsp;&nbsp;
              </label>
              <label v-if="item.icloudUser && item.icloudUser.userName">
                <span class="text-muted">{{$t('ONLINE.Customer_Name')}}:&nbsp;</span>
                <span v-if="item.icloudUser.userName">{{item.icloudUser.userName}}&nbsp;</span>
                <span v-if="item.icloudUser.email">{{item.icloudUser.email}}&nbsp;</span>
                <span v-if="item.icloudUser.phone">{{item.icloudUser.phone}}&nbsp;</span>
              </label>
              <span v-if="item.configMainName"><span class="text-muted">{{$t('ONLINE.Product_Type')}}:&nbsp;</span>{{item.configMainName}}&nbsp;&nbsp;&nbsp;</span>
              <span class="font-size-sm text-muted">{{$t('ONLINE.Offline_Transfer')}}&nbsp;&nbsp;&nbsp;</span>
              <label v-if="item.status">
                <span class="label label-lg label-light-primary label-inline" v-if="item.status == 1">{{$t('ONLINE.To_be_confirmed')}}</span>
                <span class="label label-lg label-light-primary label-inline" v-if="item.status == 2">{{$t('ONLINE.Pending_Approval')}}</span>
                <span class="label label-lg label-light-primary label-inline" v-if="item.status == 3">{{$t('ONLINE.due')}}</span>
                <span class="label label-lg label-light-primary label-inline" v-if="item.status == 4">{{$t('ONLINE.In_Production')}}</span>
                &nbsp;&nbsp;&nbsp;
              </label>
              <label v-if="item.contractDetail">
                <span class="label label-lg label-light-primary label-inline" v-if="item.contractDetail && item.contractDetail.countName">{{$t('ONLINE.The_order_is_going_through_production')}}</span>
                <span class="label label-lg label-light-primary label-inline" v-if="item.contractDetail && item.contractDetail.feedingName && !item.contractDetail.countName">{{$t('ONLINE.The_order_has_been_placed')}}</span>
                <span class="label label-lg label-light-primary label-inline" v-if="item.contractDetail && item.contractDetail.cardName && !item.contractDetail.feedingName && !item.contractDetail.countName">{{$t('ONLINE.Orders_have_been_made_for_engineering_cards')}}</span>
                <span class="label label-lg label-light-primary label-inline" v-if="item.contractDetail && item.contractDetail.approvalName && !item.contractDetail.cardName && !item.contractDetail.feedingName && !item.contractDetail.countName">{{$t('ONLINE.Order_has_been_approved')}}</span>
                &nbsp;&nbsp;&nbsp;
              </label>
            </div>
          </div>
          <div class="row">
            <div class="col-xl-12 p-1">
              <label v-if="item.quantity">
                <span class="text-muted">{{$t('ONLINE.QUANTITY')}}:&nbsp;</span>{{item.quantity}}pcs&nbsp;&nbsp;&nbsp;
              </label>
              <label v-if="item.setSize">
                <span class="text-muted">{{$t('ONLINE.SIZE')}}:&nbsp;</span>{{item.setSize}}&nbsp;&nbsp;&nbsp;
              </label>
              <label v-if="item.orderDeailArea">
                <span class="text-muted">{{$t('ONLINE.area')}}:&nbsp;</span><span>{{ item.orderDeailArea }}㎡</span>&nbsp;&nbsp;&nbsp;
              </label>
              <label v-if="item.subTotal">
                <span class="text-muted">{{$t('ONLINE.amount')}}:&nbsp;</span>
                <label v-if="item.exchangeType && item.exchangeRate > 0">
                  <span v-if="item.exchangeType == 'USD'">$</span>
                  <span v-if="item.exchangeType == 'HKD'">HK$</span>
                  {{(item.subTotal / item.exchangeRate).toFixed(4)}}
                </label>
                <label v-else>
                  ￥{{ item.subTotal }}
                </label>
                &nbsp;&nbsp;&nbsp;
              </label>
              <label v-if="item.createdDate">
                <span class="text-muted">{{$t('ONLINE.Order_Time')}}:&nbsp;</span>{{item.createdDate}}&nbsp;&nbsp;&nbsp;
              </label>
              <label v-if="item.deliveryDateStr">
                <span class="text-muted">{{$t('ONLINE.Order_Delivery_Time')}}:&nbsp;</span>{{item.deliveryDateStr}}&nbsp;&nbsp;&nbsp;
              </label>
            </div>
          </div>
          <div class="row">
            <div class="col-xl-12 p-1">
              <span class="text-muted">{{$t('ONLINE.specification')}}:&nbsp;</span>
              <template v-for="row in item.deailList">
                <label :key="row.recordId">
                  <span v-if="row.inputType == 1 && row.value">{{row.value}}{{row.unitType}}&nbsp;&nbsp;&nbsp;</span>
                  <span v-if="row.inputType == 2 && row.value1">{{row.value1}}*{{row.value2}}&nbsp;&nbsp;&nbsp;</span>
                  <span v-if="row.inputType == 3 && row.value1">{{row.value1}}*{{row.value2}}/{{row.value3}}&nbsp;&nbsp;&nbsp;</span>
                  <span v-if="row.inputType == 4 && row.dictValue">{{row.dictValue}}&nbsp;&nbsp;&nbsp;</span>
                  <span v-if="row.inputType == 5 && row.dictValue">{{row.dictValue}}&nbsp;&nbsp;&nbsp;</span>
                  <span v-if="row.inputType == 6">{{$t('ONLINE.PICTURE')}}&nbsp;&nbsp;&nbsp;</span>
                  <span v-if="row.inputType == 7 && row.value">{{row.value}}&nbsp;&nbsp;&nbsp;</span>
                </label>
              </template>
            </div>
          </div>
          <div class="row" v-if="item.attaList && item.attaList.length > 0">
            <div class="col-xl-12 p-1">
              <span class="text-muted">{{$t('ONLINE.Data_files')}}</span>:&nbsp;
              <template v-for="(item,indexI) in item.attaList">
                <label class="pb-1" :key="item.recordId">
                  {{ $t('ONLINE.DOCUMENT') }}{{indexI + 1}}(<a href="#" v-on:click="showPreview(item)">{{ item.orgFileName }}</a>)
                </label>
              </template>
            </div>
          </div>
        </div>
      </div>
    </template>
    <b-modal ref="confirmOrder" hide-footer>
      <template v-slot:modal-header="{ close }">
        <h5>{{titleOpen}}</h5>
        <b-button size="sm" variant="outline-danger" @click="close()">
          {{$t('CRAFTVALUE.Close')}}
        </b-button>
      </template>
      <div class="row">
        <div class="col-xl-12 text-warning">
          <h4>{{contentOpen}}</h4>
        </div>
      </div>
      <div class="row border-top">
        <div class="col-xl-12 text-right">
          <button type="button" class="btn btn-sm btn-primary" v-on:click="submitOrder()">{{$t('ONLINE.confirm')}}</button>&nbsp;
          <button type="button" class="btn btn-sm btn-default" v-on:click="closeConfirmOrder">{{$t('ONLINE.Cancel')}}</button>
        </div>
      </div>
    </b-modal>
    <b-modal ref="deleteOrder" hide-footer>
      <template v-slot:modal-header="{ close }">
        <h5>{{$t('ORDER.Delete_Order')}}</h5>
        <b-button size="sm" variant="outline-danger" @click="close()">
          {{$t('CRAFTVALUE.Close')}}
        </b-button>
      </template>
      <div class="row">
        <div class="col-xl-12 text-danger">
          <h4>{{$t('ORDER.Cancel_Order')}}</h4>
        </div>
      </div>
      <div class="row border-top">
        <div class="col-xl-12 text-right">
          <button type="button" class="btn btn-sm btn-danger" v-on:click="deleteTheOrder">{{$t('ONLINE.confirm')}}</button>&nbsp;
          <button type="button" class="btn btn-sm btn-default" v-on:click="closeDeleteOrder">{{$t('ONLINE.Cancel')}}</button>
        </div>
      </div>
    </b-modal>
    <b-modal ref="upload" hide-footer  size="xl">
      <template v-slot:modal-header="{ close }">
        <h5>{{$t('ONLINE.Attachment_management')}}</h5>
        <b-button size="sm" variant="outline-danger" @click="close()">
          {{$t('CRAFTVALUE.Close')}}
        </b-button>
      </template>
      <div class="row align-items-center">
        <div class="col-xl-6">
          <span>{{$t('ORDER.File_list')}}</span>
        </div>
        <div class="col-xl-6 text-right">
          <button class="btn btn-sm btn-outline-primary">{{ $t('ONLINE.Upload_attachment') }}</button>
          <a href="javascript:;" class="fileUp">
            <input id="file" type="file" multiple="multiple" v-on:change="checkFile">
          </a>
        </div>
      </div>
      <div class="row border-top">
        <div class="col-xl-12">
          {{$t('ONLINE.attachments')}}
        </div>
      </div>
      <div class="row border-top" v-if="fileList">
        <template v-for="(item,index) in fileList">
          <div class="col-xl-12" :key="index">
            <div class="row pb-1 align-items-center border-top" :key="index">
              <div class="col-xl-9">
                {{item.name}}
              </div>
              <div class="col-xl-3 text-right">
                <a :href="item.downloadUrl" v-if="item.downloadUrl"><button class="btn btn-sm btn-warning px-1 py-1">
                  {{$t('ONLINE.Download')}}</button>
                </a>&nbsp;
                <button class="btn btn-sm btn-danger px-1 py-1" v-on:click="delAttachment(index)">{{$t('ONLINE.delete')}}</button>&nbsp;
                <button class="btn btn-sm btn-success px-1 py-1" v-on:click="showPreview(item)">{{$t('ONLINE.Preview')}}</button>
              </div>
            </div>
          </div>
        </template>
      </div>
      <div class="row border-top pt-7">
        <div class="col-xl-12 text-right">
          <button type="button" class="btn btn-sm btn-primary" v-on:click="submitUpload()">{{$t('ONLINE.confirm')}}</button>&nbsp;
          <button type="button" class="btn btn-sm btn-default" v-on:click="closeUpload">{{$t('ONLINE.Cancel')}}</button>
        </div>
      </div>
    </b-modal>
    <b-modal ref="previewId" hide-footer size="xl">
      <template v-slot:modal-header="{ close }">
        <h5></h5>
        <b-button size="sm" variant="outline-danger" @click="close()">
          {{$t('CRAFTVALUE.Close')}}
        </b-button>
      </template>
      <div class="row">
        <div class="col-xl-12">
          <img id="preview" src="" class="w-100">
        </div>
      </div>
    </b-modal>
  </div>
</template>
<style>
#filetest{ position:absolute; z-index:100; margin-left:-180px; font-size:60px;opacity:0;filter:alpha(opacity=0); margin-top:-5px;}
.fileUp input {
  position: absolute;
  right: 0;
  top: 0;
  opacity: 0;/*关键点*/
  filter: alpha(opacity=0);/*兼容ie*/
  font-size: 20px;/* 增大不同浏览器的可点击区域 */
  cursor: pointer;
}
</style>
<script>
import router from "@/router";
export default {
  props: {
    productPageList: Array,
    user: Object,
    loadOrderList: {
      type: Function,
      require: true,
      default: null,
    }
  },
  data() {
    return {
      productList: [],
      interProductList:[],
      statusNum:null,
      titleOpen:'',
      contentOpen:'',
      fileList:[],
      clickFlag:true,
      temp:0,
    };
  },
  methods: {
    openUpload(item){
      this.interProduct = item;
      if (item.attaList) {
        this.fileList = item.attaList
      }
      this.$refs['upload'].show();
    },
    updateOrder(item){
      window.localStorage.setItem('order', JSON.stringify(item));
      router.push("/offers");
    },
    confirmTheOrder(item,num) {
      if(!num)
      {
        return;
      }
      this.statusNum = num;
      this.interProductList = [];
      if(item)
      {
        this.interProductList.push(item);
      }else{
        for(let obj of this.productPageList)
        {
          if(obj.checked)
          {
            if(this.statusNum == 2 && obj.status && obj.status == 1)
            {
              this.interProductList.push(obj);
            }
            else if(this.statusNum == 3 && obj.status && obj.status == 2)
            {
              this.interProductList.push(obj);
            }
            else if(this.statusNum == 4 && obj.status && obj.status == 3)
            {
              this.interProductList.push(obj);
            }
          }
        }
      }
      this.titleOpen = null;
      this.contentOpen = null;
      if(this.statusNum == 2)
      {
        this.titleOpen = this.$t('ORDER.Confirm_The_Order');
        this.contentOpen = this.$t('ORDER.Sales_Order');
      }
      else if(this.statusNum == 3)
      {
        this.titleOpen = this.$t('ORDER.Audit_The_Order');
        this.contentOpen = this.$t('ORDER.Audit_Order');
      }
      else if(this.statusNum == 4)
      {
        this.titleOpen = this.$t('ORDER.Pay_Confirm_The_Order');
        this.contentOpen = this.$t('ORDER.Pay_Sales_Order');
      }
      this.$refs['confirmOrder'].show();
    },
    deleteOrder(item){
      this.interProduct = item;
      this.$refs['deleteOrder'].show();
    },
    repulseOrder(item,num) {
      if(!num)
      {
        return;
      }
      this.statusNum = num;
      this.interProductList = [];
      if(item)
      {
        this.interProductList.push(item);
      }else{
        for(let obj of this.productPageList)
        {
          if(obj.checked)
          {
            if(this.statusNum == 1 && obj.status && obj.status == 2)
            {
              this.interProductList.push(obj);
            }
            else if(this.statusNum == 2 && obj.status && obj.status == 3)
            {
              this.interProductList.push(obj);
            }
          }
        }
      }
      this.titleOpen = this.$t('ORDER.Order_back');
      this.contentOpen = this.$t('ORDER.Make_sure_to_return_the_order');
      this.$refs['confirmOrder'].show();
    },
    submitOrder(){
      if(!this.interProductList || this.interProductList.length == 0)
      {
        alert(this.$t('ONLINE.Please_Select_An_Order'));
        return;
      }
      if(!this.clickFlag)
      {
        alert(this.$t('ONLINE.Do_Not_Click_More_Than_Once'));
        return;
      }
      this.clickFlag = false;
      let message = null;
      if(this.titleOpen == this.$t('ORDER.Order_back'))
      {
        message = this.$t('ONLINE.Hit_Back');
      }
      else
      {
        if(this.statusNum == 2)
        {
          message = this.$t('ONLINE.Confirm_Success');
        }
        else if(this.statusNum == 3)
        {
          message = this.$t('ONLINE.Successful_Audit');
        }
        else if(this.statusNum == 4)
        {
          message = this.$t('ONLINE.Payment_Confirmation_Successful');
        }
      }

      for(let obj of this.interProductList)
      {
        obj.status = this.statusNum;
        obj.defaultDb = this.user.defaultDb;
        obj.groupManageId = this.user.groupManageId;
        obj.userId = this.user.recordId;
      }
      const _this = this;
      this.$axios.fetchPost("is/offer/confirmOrder", this.interProductList).then(result => {
        if (result.data && result.data == "success")
        {
          _this.loadOrderList()
          alert(message);
        }
        else
        {
          alert(this.$t('ONLINE.Please_refresh_and_retry'));
        }
        _this.clickFlag = true;
        _this.$refs['confirmOrder'].hide();
      }).catch(err => {alert(err)});
    },
    closeConfirmOrder() {
      this.$refs.confirmOrder.hide();
    },
    closeDeleteOrder(){
      this.$refs.deleteOrder.hide();
    },
    deleteTheOrder()
    {
      if(!this.clickFlag)
      {
        alert(this.$t('ONLINE.Do_Not_Click_More_Than_Once'));
        return;
      }
      this.clickFlag = false;
      const interProduct = {};
      interProduct.defaultDb = this.user.defaultDb;
      interProduct.groupManageId = this.user.groupManageId;
      interProduct.userId = this.user.recordId;
      interProduct.recordId = this.interProduct.recordId;
      const _this = this;
      this.$axios.fetchPost("is/offer/deleteOrder", interProduct).then(result => {
        if (result.data && result.data == "success")
        {
          _this.loadOrderList()
          alert(this.$t('ONLINE.Successfully_deleted'));
        }
        else
        {
          alert(this.$t('ONLINE.Please_refresh_and_retry'));
        }
        _this.clickFlag = true;
        _this.$refs['deleteOrder'].hide();
      }).catch(err => {alert(err)});
    },
    closeUpload() {
      this.$refs.upload.hide();
    },
    submitUpload(){
      if(!this.clickFlag)
      {
        alert(this.$t('ONLINE.Do_Not_Click_More_Than_Once'));
        return;
      }
      this.clickFlag = false;
      const param = new FormData()
      if (this.fileList && this.fileList.length > 0) {
        for (let i = 0; i < this.fileList.length; i++) {
          if (!this.fileList[i].downloadUrl) {
            param.append('files', this.fileList[i])
          }
        }
      }
      const interProduct = {};
      interProduct.defaultDb = this.user.defaultDb;
      interProduct.groupManageId = this.user.groupManageId;
      interProduct.userId = this.user.recordId;
      interProduct.recordId = this.interProduct.recordId;
      param.append('interProduct',JSON.stringify(interProduct));
      const _this = this;
      this.$axios.formPost("is/offer/uploadFile",param).then(result => {
        if (result.data == "success")
        {
          alert(this.$t('ONLINE.Save_successfully'));
          _this.$refs.upload.hide();
          _this.loadOrderList();
        }
        _this.clickFlag = true;
      }).catch(err => {
        console.log(err);
      })
    },
    checkFile(file){
      if (file.target.files && file.target.files.length > 0) {
        for (let x = 0; x < file.target.files.length; x++) {
          const f = file.target.files[x]
          const type = ['image/jpg', 'image/jpeg', 'image/png', 'application/pdf', 'application/msword', 'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
            'application/vnd.ms-excel', 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet', 'application/vnd.ms-powerpoint', 'application/vnd.openxmlformats-officedocument.presentationml.presentation']
          if (f && (type.indexOf(f.type) >= 0 || !f.type)) {
            for (const i in this.fileList) {
              if (this.fileList[i].name === f.name) {
                alert(this.$t('ONLINE.file') + f.name + this.$t('ONLINE.Already_exist'))
                return
              }
            }
            this.fileList.push(f)
          } else {
            alert(this.$t('ONLINE.Upload_only') + 'jpg/jpeg/png/pdf/doc/docx/xls/xlsx/ppt/pptx' + this.$t('ONLINE.File_name_extension'))
          }
        }
      }
    },
    delAttachment: function (index) {
      if (this.fileList[index] && this.fileList[index].downloadUrl) {
        // 删除后台关联及存储
        this.$axios.fetchPost('is/offer/delAttachment', this.fileList[index]).then((data) => {
          if (data.data) {
            if (data.data === 'success') {
              alert(this.$t('ONLINE.Successfully_deleted'));
              this.fileList.splice(index, 1)
            } else {
              alert(this.$t('ONLINE.System_error'));
            }
          }
        }).catch(err => {
              console.log(err)
            }
        )
      } else {
        this.fileList.splice(index, 1)
      }
    },
    showPreview: function (item) {
      const file = item
      const type = ['image/jpg', 'image/jpeg', 'image/png']
      const typePdf = ['application/pdf']
      const _this = this;
      if (file && type.indexOf(file.type) >= 0) {
        if (item.downloadUrl) {
          _this.$refs.previewId.show();
          _this.preview(item,item.downloadUrl);
        } else {
          const reader = new FileReader()
          reader.readAsDataURL(file)
          reader.onload = function () {
            _this.$refs.previewId.show();
            _this.preview(item,reader.result);
          }
        }
      } else if (file && typePdf.indexOf(file.type) >= 0) {
        if (item.downloadUrl) {
          const win = window.open()
          win.document.write('<body style="margin:0px;"><iframe src="' + item.downloadUrl + '" scrolling="no" width="100%" height="100%" frameborder="0" ></iframe></body>')
          win.document.close()
        } else {
          const reader = new FileReader()
          reader.readAsDataURL(file)
          reader.onload = function () {
            const win = window.open()
            win.document.write('<body style="margin:0px;"><iframe src="' + reader.result + '" scrolling="no" width="100%" height="100%" frameborder="0" ></iframe></body>')
            win.document.close()
          }
        }
      } else {
        if (item.downloadUrl) {
          if (file.type) {
            const win = window.open()
            win.document.write('<body style="margin:0px;"><iframe src="https://view.officeapps.live.com/op/view.aspx?src=' + encodeURIComponent(item.downloadUrl) + '" scrolling="no" width="100%" height="100%" frameborder="0" ></iframe></body>')
            win.document.close()
          } else {
            const strs = item.name.split('.')
            if (strs[1] === 'jpg' || strs[1] === 'JPG' || strs[1] === 'png' || strs[1] === 'PNG' || strs[1] === 'jpeg' ||
                strs[1] === 'JPEG' || strs[1] === 'bmp' || strs[1] === 'BMP' || strs[1] === 'gif' || strs[1] === 'GIF') {
              this.$refs.previewId.show();
              document.getElementById('preview').src = item.downloadUrl
            } else if (strs[1] === 'docx' || strs[1] === 'DOCX' || strs[1] === 'doc' || strs[1] === 'DOC' || strs[1] === 'xls' ||
                strs[1] === 'XLS' || strs[1] === 'xlsx' || strs[1] === 'XLSX') {
              const win = window.open()
              win.document.write('<body style="margin:0px;"><iframe src="https://view.officeapps.live.com/op/view.aspx?src=' + encodeURIComponent(item.downloadUrl) + '" scrolling="no" width="100%" height="100%" frameborder="0" ></iframe></body>')
              win.document.close()
            } else if (strs[1] === 'pdf' || strs[1] === 'PDF') {
              const win = window.open()
              win.document.write('<body style="margin:0px;"><iframe src="' + item.downloadUrl + '" scrolling="no" width="100%" height="100%" frameborder="0" ></iframe></body>')
              win.document.close()
            }
          }
        } else {
          const reader = new FileReader()
          reader.readAsDataURL(file)
          reader.onload = function () {
            const win = window.open()
            win.document.write('<body style="margin:0px;"><iframe src="' + reader.result + '" scrolling="no" width="100%" height="100%" frameborder="0" ></iframe></body>')
            win.document.close()
          }
        }
      }
    },
    preview(item,downloadUrl){
      const _this = this;
      if (document.getElementById('preview')) {
        document.getElementById('preview').src = downloadUrl;
      } else {
        if (_this.temp > 50) {
          _this.temp = 0;
          return;
        }
        _this.temp++;
        setTimeout(function () { _this.showPreview(item) }, 500);
      }
    },
  }
}
</script>